<template>
    <div class="app-nav-link" :class="{active, collapsed}">
        <inertia-link :href="href">

            <div class="icon-wrap">
                <div class="icon"><slot class="icon-inactive" name="icon"><img :src="`/images/icons/${icon}.svg`" alt=""></slot></div>
                <div class="icon icon-active"><slot name="icon-active"><img :src="'/images/icons/' + (iconActive ? iconActive : icon) + '.svg'" alt=""></slot></div>
            </div>

            <!-- Link text -->
            <div class="link-text">
                <slot></slot>
            </div>
        </inertia-link>

    </div>
</template>

<script>
export default {
    name: "AppNavLink",
    props: ['active', 'collapsed', 'href', 'icon', 'iconActive'],
}
</script>

<style lang="scss" scoped>

a{
    text-decoration: none;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
}

.icon-wrap{
    width: 3rem;
    text-align: center;
    margin-right: 0.6rem;
    padding-left: 0.8rem;
}
.icon{
    padding: 0.4rem;
}

.icon-active{
    display: none;
}

.active{
    .icon-wrap{
        border-radius: 0 6px 6px 0;
    }

    .icon{
        display: none;

        &.icon-active{
            display: block;
        }
    }
}

.collapsed{
    position: relative;

    .link-text{
        display: none;
        position: absolute;
        left: 100%;
        top: 50%;
        transform: translate(8px, -50%);
        padding: 0.25rem 0.4rem;
        background: $dark;
        color: $light;
        border-radius: 6px;
        font-size: 0.8rem;

        &:before{
            content: '';
            position: absolute;
            left: -12px;
            top: 50%;
            transform: translateY(-50%);
            border: transparent solid 6px;
            border-right-color: $dark;
        }
    }

    .icon-wrap{
        padding-left: 0.4rem;
    }

    a:hover{
        .link-text{
            display: block;
        }
    }

}

</style>
